<template>
    <div class="container pt-100" id="differentes_etapes">
        <div class="titre">
            <h2 class="text-uppercase">
                <span class="span-background">
                    Les différentes étapes du bilan
                </span>
            </h2>
        </div>
        <div class="d-flex flex-column gap-3 steps">
            <div class="d-flex justify-content-between stepItem">
                <div class="position-relative">
                    <div class="vr position-absolute"></div>
                    <div class="position-relative">
                        <nuxt-img src="/images/icon/Ellipse 6.png"></nuxt-img>
                        <div class="stepNumber">1.</div>
                    </div>
                </div>
                <div class="bodyStep">
                    <h3>L’entretien préalable</h3>
                    <div class="textBodyStep" :class="{ collapsed: isCollapsed1 }">
                        <p>Nos consultants sont à votre disposition pour un 1erRDV, gratuit et sans engagement.</p>
                        <ul class="ul-position">
                            <li>Ce 1er entretien permet d'échanger sur le déroulé global du bilan</li>
                            <li>De vérifier que le feeling est bien au rendez-vous avec le consultant.</li>
                            <li>De faire le tour des objectifs du bilan de compétences, des outils et méthodes
                                utilisées.
                            </li>
                            <li>Ensuite, notre équipe vous accompagnera dans les démarches administratives jusqu'au
                                démarrage du bilan compétences.</li>
                        </ul>
                    </div>
                </div>
                <div class="btn-collapse">
                    <nuxt-img src="/images/icon/circle-plus.png" :class="{ expanded: isExpanded1 }"
                        @click="collapsedTextBodySteps(1)"></nuxt-img>
                    <nuxt-img src="/images/icon/circle-minus.png" class="minus" :class="{ collapsed: isCollapsed1 }"
                        @click="collapsedTextBodySteps(1)"></nuxt-img>
                </div>
            </div>
            <div class="d-flex justify-content-between stepItem">
                <div class="position-relative">
                    <div class="vr position-absolute"></div>
                    <div class="position-relative">
                        <nuxt-img src="/images/icon/Ellipse 6.png"></nuxt-img>
                        <div class="stepNumber">2.</div>
                    </div>
                </div>
                <div class="bodyStep">
                    <h3>La phase préliminaire</h3>
                    <div class="textBodyStep" :class="{ collapsed: isCollapsed2 }">
                        <p>Cette phase permet de clarifier votre démarche: </p>
                        <ul class="ul-position">
                            <li>D'établir une relation de confiance avec le consultant.</li>
                            <li>D'analyser vos attentes de manière personnalisée et d'adapter le bilan de compétences à
                                votre demande.</li>
                        </ul>
                    </div>
                </div>
                <div class="btn-collapse">
                    <nuxt-img src="/images/icon/circle-plus.png" :class="{ expanded: isExpanded2 }"
                        @click="collapsedTextBodySteps(2)"></nuxt-img>
                    <nuxt-img src="/images/icon/circle-minus.png" class="minus" :class="{ collapsed: isCollapsed2 }"
                        @click="collapsedTextBodySteps(2)"></nuxt-img>
                </div>
            </div>
            <div class="d-flex justify-content-between stepItem">
                <div class="position-relative">
                    <div class="vr position-absolute"></div>
                    <div class="position-relative">
                        <nuxt-img src="/images/icon/Ellipse 6.png"></nuxt-img>
                        <div class="stepNumber">3.</div>
                    </div>
                </div>
                <div class="bodyStep">
                    <h3>La phase d'investigation</h3>
                    <div class="textBodyStep" :class="{ collapsed: isCollapsed3 }">
                        <p>Cette troisième étape permet de :</p>
                        <ul class="ul-position">
                            <li>Identifier les étapes essentielles dans votre histoire de vie afin de pouvoir les
                                valoriser.
                            </li>
                            <li>Dresser avec vous un portrait de votre personnalité pour connaître vos atouts, vos
                                valeurs
                                et motivations professionnelles indispensables pour définier un projet professionnel
                                cohérent.</li>
                            <li>De lister et vous réapproprier vos savoir-faire, connaissance et aptitudes
                                professionnelles.
                            </li>
                            <li>D'identifier de nouvelles voies professionnelles plus en accord avec qui vous êtes, et,
                                d'analyser l'environnement socio-économique et les débouchés des projets visés.</li>
                            <li>Identifier le plan d'action nécessaire à la réalisation du nouveau projet formation,
                                mobilité externe, interne, stratégie de recherche d'emploi.</li>
                        </ul>
                    </div>
                </div>
                <div class="btn-collapse">
                    <nuxt-img src="/images/icon/circle-plus.png" :class="{ expanded: isExpanded3 }"
                        @click="collapsedTextBodySteps(3)"></nuxt-img>
                    <nuxt-img src="/images/icon/circle-minus.png" class="minus" :class="{ collapsed: isCollapsed3 }"
                        @click="collapsedTextBodySteps(3)"></nuxt-img>
                </div>
            </div>
            <div class="d-flex justify-content-between stepItem">
                <div class="position-relative">
                    <div class="vr position-absolute"></div>
                    <div class="position-relative">
                        <nuxt-img src="/images/icon/Ellipse 6.png"></nuxt-img>
                        <div class="stepNumber">4.</div>
                    </div>
                </div>
                <div class="bodyStep">
                    <h3>La phase de conclusion</h3>
                    <div class="textBodyStep" :class="{ collapsed: isCollapsed4 }">
                        <p>Pour cette dernière étape :</p>
                        <ul class="ul-position">
                            <li>Vous validez le projet que vous souhaitez conserver et mettre en place.</li>
                            <li>Votre consultant vous remet la synthèse écrite de votre bilan de compétences.</li>
                            <li>Cette synthèse retrace l'ensemble de votre projet professionnel et le plan d'action pour
                                le
                                concrétiser.</li>
                        </ul>
                    </div>
                </div>
                <div class="btn-collapse">
                    <nuxt-img src="/images/icon/circle-plus.png" :class="{ expanded: isExpanded4 }"
                        @click="collapsedTextBodySteps(4)"></nuxt-img>
                    <nuxt-img src="/images/icon/circle-minus.png" class="minus" :class="{ collapsed: isCollapsed4 }"
                        @click="collapsedTextBodySteps(4)"></nuxt-img>
                </div>
            </div>
            <div class="d-flex justify-content-between stepItem">
                <div class="position-relative">
                    <div class="vr position-absolute"></div>
                    <div>
                        <nuxt-img src="/images/icon/Ellipse 6.png"></nuxt-img>
                        <div class="stepNumber">5.</div>
                    </div>
                </div>
                <div class="bodyStep">
                    <h3>Le suivi à 6 mois</h3>
                    <div class="textBodyStep" :class="{ collapsed: isCollapsed5 }">
                        <p>6 mois après votre bilan, votre consultant.e vous contacte pour faire le point sur votre
                            situation professionnelle et vous faire bénéficier de conseils supplémentaire, si
                            nécessaire.
                        </p>
                    </div>
                </div>
                <div class="btn-collapse">
                    <nuxt-img src="/images/icon/circle-plus.png" :class="{ expanded: isExpanded5 }"
                        @click="collapsedTextBodySteps(5)"></nuxt-img>
                    <nuxt-img src="/images/icon/circle-minus.png" class="minus" :class="{ collapsed: isCollapsed5 }"
                        @click="collapsedTextBodySteps(5)"></nuxt-img>
                </div>
            </div>
        </div>
        <div class="titre" id="financement">
            <h2 class="text-uppercase pb-3">
                <span class="span-background">
                    Le financement
                </span>
            </h2>
            <div class="pb-3 text-center">
                <i class="fa-solid fa-circle-info"></i>
            </div>
            <div class="mt-20 textTitre">
                <p class="pb-3">Le Bilan de compétences peut être finançable avec votre CPF.</p>
                <p class="pb-3">
                    <a href="https://www.moncompteformation.gouv.fr/"
                        target="_blank">https://www.moncompteformation.gouv.fr/ </a>
                </p>
                <div class="pb-50">
                    <p class="">
                        Il peut également être financé :
                    </p>
                    <ul class="text-start ul-position-financement">
                        <li>
                            avec le plan de développement des compétences avec l’accord de votre employeur
                        </li>
                        <li>
                            par France Travail si vous êtes demandeur d’emploi
                        </li>
                        <li>
                            ou avec d’autres financements selon votre profil.
                        </li>
                    </ul>
                </div>
                <p class="pb-3">
                    Pour en savoir plus, contactez-nous.​
                </p>
                <div class="d-sm-flex align-items-center justify-content-center button-group">
                    <a href="/contactez-nous " class="d-flex align-items-center contact">
                        Formulaire de contact
                        <i class="fa-solid fa-arrow-right"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
const isCollapsed1 = ref(false)
const isCollapsed2 = ref(false)
const isCollapsed3 = ref(false)
const isCollapsed4 = ref(false)
const isCollapsed5 = ref(false)

const isExpanded1 = ref(false)
const isExpanded2 = ref(false)
const isExpanded3 = ref(false)
const isExpanded4 = ref(false)
const isExpanded5 = ref(false)

const collapsedTextBodySteps = (number) => {
    switch (number) {
        case 1:
            isCollapsed1.value = !isCollapsed1.value
            isExpanded1.value = !isExpanded1.value
            break
        case 2:
            isCollapsed2.value = !isCollapsed2.value
            isExpanded2.value = !isExpanded2.value
            break
        case 3:
            isCollapsed3.value = !isCollapsed3.value
            isExpanded3.value = !isExpanded3.value
            break
        case 4:
            isCollapsed4.value = !isCollapsed4.value
            isExpanded4.value = !isExpanded4.value
            break
        case 5:
            isCollapsed5.value = !isCollapsed5.value
            isExpanded5.value = !isExpanded5.value
            break
    }

}
</script>
<style scoped>
.ul-position {
    padding: 20px 50px;
    gap: 1rem;
    color: var(--accent, #25233E);

    /* txt */
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 144%;
    letter-spacing: 0.72px;
}


.ul-position-financement {
    color: var(--accent, #25233E);

    /* txt */
    font-family: Inter;
    font-size: 21px;
    font-style: normal;
    font-weight: 400;
    line-height: 144%;
    letter-spacing: 0.72px;
    padding: 20px 350px;
}

.titre {
    border-radius: 30px;
    border: 3px solid var(--secondaire, #FAB74B);
    padding: 60px 50px;
}

h2 {
    font-family: Nunito;
    font-size: 50px;
    font-style: normal;
    font-weight: 600;
    line-height: 111.5%;
    /* 61.325px */
    letter-spacing: -0.825px;
    text-transform: uppercase;
    text-align: center;
}

.textTitre {
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 144%;
    /* 25.92px */
    letter-spacing: 0.72px;
    text-align: center;
}

.textTitre p:nth-child(1),
.textTitre p:nth-child(4) {
    /* h3 */
    font-family: Nunito;
    font-size: 34px;
    font-weight: 500;
    line-height: 111.5%;
    /* 37.91px */
    letter-spacing: -0.51px;
}

.textTitre p:nth-child(2) a {
    color: #318EC7;
    font-size: 21px;
    font-style: normal;
    font-weight: 600;
    line-height: 133%;
    /* 27.93px */
    letter-spacing: 0.84px;
    text-decoration-line: underline;
}

.textTitre p:nth-child(3) {
    font-weight: 600;
    line-height: 144%;
    /* 25.92px */
    letter-spacing: 0.72px;
    padding-left: 14rem;
    padding-right: 14rem;
}

.steps {
    margin: 0 5rem 0 5rem;
    overflow: hidden;
}

.stepItem {
    min-height: 120px;
    align-items: center;
}

.vr {
    background-color: #fab74b;
    left: 44%;
    min-height: 46em;
    opacity: 1;
    top: -449%;
    width: 8px;
}

.stepNumber {
    font-family: Nunito;
    font-size: 34px;
    font-style: normal;
    font-weight: 500;
    line-height: 111.5%;
    /* 37.91px */
    letter-spacing: -0.51px;
    position: absolute;
    top: 27%;
    left: 35%;
    z-index: 2;
}

.bodyStep {
    width: 80%;
}

p {
    font-size: 18px;
}

ul {
    list-style-type: disc;
    padding-left: 2rem;
}

.textBodyStep,
.minus,
.expanded {
    display: none;
}

.collapsed {
    display: block;
}

.contact {
    column-gap: 1rem;
}

.fa-circle-info {
    font-size: 48px;
    color: #318EC7;
}

@media only screen and (min-width: 300px) and (max-width: 374px) {
    h3 {
        font-size: 20px !important;
    }

    .textTitre p {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }

    .textTitre p:nth-child(2) a {
        font-size: 9px !important;
    }

    button-group a {
        width: 20% !important;
    }

    .contact {
        width: 100% !important;
    }

    .vr {
        top: -2000%;
        left: 45%;
        min-height: 150em;
    }

    .bodyStep h3 {
        margin-top: 0px;
        margin-left: 20px;
    }

    .stepNumber {
        font-size: 16px;
        top: 40%;
        left: 40%;
        z-index: 2;
    }

    .position-relative img,
    .btn-collapse img {
        min-width: 20px !important;
    }

    .btn-collapse img {
        position: unset;
        margin-left: -5px !important;
        width: 25px !important;
        margin-top: -10px;
    }

    .steps {
        margin: 0 0rem 0 0rem;
    }

    .bodyStep {
        width: 80%;
    }

    .ul-position {
        padding: 10px 10px;
        font-size: 14px;
        margin-left: 55px;
    }

    .ul-position-financement {
        font-size: 14px;
        padding: 20px 60px;
    }

    p {
        margin-bottom: 1rem;
        margin-top: 1rem;
        margin-left: 20px;
        line-height: 144%;
    }

    .titre {
        padding: 30px 10px;
    }
}

@media only screen and (min-width: 375px) and (max-width: 426px) {
    h3 {
        font-size: 20px !important;
    }

    .textTitre p {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }

    .textTitre p:nth-child(2) a {
        font-size: 9px !important;
    }

    button-group a {
        width: 20% !important;
    }

    .contact {
        width: 100% !important;
    }

    .vr[data-v-9d194820] {
        top: -3532%;
        left: 34%;
        min-height: 150em;
    }

    .bodyStep h3 {
        margin-top: 10px;
        margin-left: 20px;
    }

    .stepNumber {
        font-size: 16px;
        top: 38%;
        z-index: 2;
        left: 33%;
    }

    .position-relative img {
        min-width: 20px !important;
    }

    .btn-collapse img {
        max-width: 25px !important;
    }

    .steps {
        margin: 0 0rem 0 0rem;
    }

    .bodyStep {
        width: 65%;
    }

    .position-relative img {
        max-width: 80%;
    }

    .ul-position {
        padding: 10px 10px;
        font-size: 14px;
        margin-left: 16px;
    }

    .ul-position-financement {
        font-size: 14px;
        padding: 20px 60px;
    }

    p {
        margin-bottom: 1rem;
        margin-top: 1rem;
        margin-left: 20px;
        line-height: 144%;
    }
}

@media only screen and (min-width: 501px) and (max-width: 768px) {
    h3 {
        font-size: 20px !important;
    }

    .ul-position {
        padding: 10px 10px;
        gap: 1rem;
        font-size: 14px;
    }
    .ul-position-financement {
        font-size: 14px;
        padding: 20px 160px;
    }
}


/* Pour les appareils entre 768px et 991px de large (tablettes en mode paysage) */
@media only screen and (min-width: 769px) and (max-width: 991px) {}

/* Pour les appareils entre 992px et 1199px de large (tablettes en mode portrait et ordinateurs portables) */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
    .container {
        max-width: 950px !important;
    }

    p {
        font-size: 18px !important;
    }

    ul li {
        font-size: 17px !important;
    }
    .ul-position-financement {
        font-size: 14px;
        padding: 20px 260px;
    }


}

@media only screen and (min-width: 938px) and (max-width: 1275px) {}

/* Pour les appareils de 1200px de large et plus (ordinateurs de bureau) */
@media only screen and (min-width: 1200px) {}
</style>